import {dataTestId} from '@hconnect/uikit'
import {Add} from '@mui/icons-material'
import {Box, Button, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {DayPeriod} from '../types'

import {StrengthTargetTabs} from './StrengthTargetTabs'

interface StrengthTargetTabsWithActionsProps {
  selectedTab: DayPeriod | 'overview'
  hasTargetsForSelectedDay: boolean
  isReadOnly: boolean
  isMobile: boolean
  onTabChange: (tab: DayPeriod | 'overview') => void
  onNewTarget: () => void
}

export const StrengthTargetTabsWithActions: React.FC<StrengthTargetTabsWithActionsProps> = ({
  selectedTab,
  hasTargetsForSelectedDay,
  isReadOnly,
  isMobile,
  onTabChange,
  onNewTarget
}) => {
  const {t} = useTranslation()

  const showNewTargetButton =
    !isMobile && !isReadOnly && selectedTab !== 'overview' && hasTargetsForSelectedDay

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      alignItems={isMobile ? 'stretch' : 'center'}
      justifyContent={isMobile ? 'flex-start' : 'space-between'}
      spacing={isMobile ? 0 : 2}
      sx={{width: '100%'}}
      {...dataTestId('tabs_and_actions_row')}
    >
      <Box sx={{flexShrink: 0}}>
        <StrengthTargetTabs selectedTab={selectedTab} onTabChange={onTabChange} />
      </Box>

      {showNewTargetButton && (
        <Button
          variant="text"
          startIcon={<Add />}
          onClick={onNewTarget}
          sx={{
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            flexShrink: 0
          }}
          {...dataTestId('new_target_button_top')}
        >
          {t('materialsSettings.strengthTargets.newTarget')}
        </Button>
      )}
    </Stack>
  )
}
